import { legacyApiAuth } from '../../apis'
import { IResponseService } from '../charts'
import type {
  GetStatusV2,
  IPortalLightCredential,
  IPortals
} from '../../interfaces/src'

export const getPublishedInPortals = async (): Promise<
  IResponseService<IPortals[]>
> => {
  const response = await legacyApiAuth.get<IPortals[]>(
    `/v2.0.2/properties/published_in_portals`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getPortalsLightCredentials = async (): Promise<
  IResponseService<IPortalLightCredential[]>
> => {
  const response = await legacyApiAuth.get<IPortalLightCredential[]>(
    `/v2.0.2/portals/light-credentials`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getAssociations = async (
  /*
   * When send 2 or more propertyIds, separate them by commas
   * Example: 'propertyIds=1,2,3'
   */
  propertyIds?: string
): Promise<IResponseService<IPortalLightCredential[]>> => {
  const response = await legacyApiAuth.get<IPortalLightCredential[]>(
    `/v2.0.2/property/my/associations${
      propertyIds ? `?property_ids=${propertyIds}` : ''
    }`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getPortalsV2 = async (
  propertiesIds?: string
): Promise<IResponseService<GetStatusV2>> => {
  const response = await legacyApiAuth.get<GetStatusV2>(
    `/v2.0.2/portals/status_v2${
      propertiesIds ? `?property_ids=${propertiesIds}` : ''
    }`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
